( function () {
	'use strict';

	function getRoutes () {
		return [
			{
				'url' : '/login',

				'config' : {
					'templateUrl'  : '/templates/login/login.html',
					'controller'   : 'Login',
					'controllerAs' : 'vm',
					'title'        : 'Login',
					'access'       : {
						'requiredLogin' : false
					}
				}
			},
			{
				'url' : '/authenticate',

				'config' : {
					'templateUrl'  : '/templates/login/authenticate.html',
					'controller'   : 'Authenticate',
					'controllerAs' : 'vm',
					'title'        : 'Authenticate',
					'access'       : {
						'requiredLogin' : false
					}
				}
			}
		];
	}

	/* @ngInject */
	function appRun ( routehelper ) {
		routehelper.configureRoutes( getRoutes() );
	}

	angular
		.module( 'app.login' )
		.run( appRun );
} )( );
